(function() {
  'use strict';
  function patchFbq() {
    if (typeof window.fbq !== 'function') {
      setTimeout(patchFbq, 100);
      return;
    }
    var originalFbq = window.fbq;
    window.fbq = function() {
      var args = Array.prototype.slice.call(arguments);
      if (args[0] === 'trackCustom' && args[1] === 'gty_whatsapp_button_click') {
        args[2] = Object.assign({}, args[2] || {}, {
          currency: 'PEN',
          value: 1
        });
      }
      return originalFbq.apply(this, args);
    };
    for (var key in originalFbq) {
      if (originalFbq.hasOwnProperty(key)) {
        window.fbq[key] = originalFbq[key];
      }
    }
  }
  patchFbq();
})();
